/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit-session': {
    width: 26,
    height: 32,
    viewBox: '0 0 26 32',
    data: '<path pid="0" d="M23.533 4.11H18.65a1 1 0 010-2h5.883a1 1 0 011 1v25.32c0 1.703-1.307 3.11-2.96 3.11H2.96C1.307 31.54 0 30.132 0 28.43V3.11a1 1 0 011-1h5.478a1 1 0 010 2H2v24.32c0 .63.446 1.11.961 1.11h19.611c.515 0 .961-.48.961-1.11V4.11z"/><path pid="1" d="M7.883 2v4.31c0-.003 3.255-.003 9.764 0 .002 0 .003-1.437.003-4.31H7.883zM19.65 1v5.31a2 2 0 01-2.003 2h-9.76c-1.105 0-2.004-.9-2.004-2V1a1 1 0 011-1H18.65a1 1 0 011 1zm-5.017 11.364a.9.9 0 011.273 0l2.423 2.423a.9.9 0 010 1.272l-7.27 7.27a.9.9 0 01-.636.263H8a.9.9 0 01-.9-.9V20.27a.9.9 0 01.264-.636l7.269-7.27zM8.9 20.642v1.15h1.15l6.37-6.369-1.15-1.15-6.37 6.369z"/>'
  }
})
